export default "__VITE_ASSET__DwTJ$I45__"